import { render } from "./UserPostsList.vue?vue&type=template&id=3ebd9b2e"
import script from "./UserPostsList.vue?vue&type=script&lang=js"
export * from "./UserPostsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__